import { render, staticRenderFns } from "./ManageFacebookPixel.vue?vue&type=template&id=17647fcc&scoped=true&"
import script from "./ManageFacebookPixel.vue?vue&type=script&lang=js&"
export * from "./ManageFacebookPixel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17647fcc",
  null
  
)

export default component.exports